import { render } from "./fullscreenIframePlayer.vue?vue&type=template&id=07d3c9ba"
import script from "./fullscreenIframePlayer.vue?vue&type=script&lang=js"
export * from "./fullscreenIframePlayer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__